import React, { useState } from 'react'
import { FieldArray } from 'formik';
import {
  Box,
  Button,
  Divider,
  Typography,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import TechProductForm from './TechProductForm';
import MasProductModalContainer from '../../../containers/common/form/modal/MasProductModalContainer';
import _ from 'lodash';

const TechProductListForm = ({ formik }) => {
  const [open, setOpen] = useState(false);
  const [arrayHelpers, setArrayHelpers] = useState(null);

  const handleOpen = (arrayHelpers) => {
    setOpen(true);
    setArrayHelpers(arrayHelpers);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const selectedProducts = (newProduct) => {
    //동일한 상품 있는지 체크할것.
    const checkDup = _.filter(formik.values.prdtList, (item)=> item.productUuid === newProduct.productUuid);
    
    if(checkDup.length  === 0){
      newProduct.productCnt = 1;
      arrayHelpers.push(newProduct);
    }else{
      alert("이미 선택한 제품입니다.");
      return;
    }
    
  }

  return (
    <div>
      <FieldArray
        name="prdtList"
        render={arrayHelpers => (
          <Box>
            {formik.values?.prdtList.length === 0 ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Typography variant="subtitle2" component="div">공급제품이 없습니다.</Typography>
              </Box>

            ) : (
              <TableContainer component={Box}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>제품명</TableCell>
                      <TableCell>모델명</TableCell>
                      <TableCell>제조업체</TableCell>
                      <TableCell>수량</TableCell>
                      <TableCell>삭제</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formik.values?.prdtList.map((p, index) => {
                      return (
                        <TechProductForm
                          key={index}
                          product={p}
                          index={index}
                          formik={formik}
                          handleRemove={() => arrayHelpers.remove(index)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my:1 }}>
              <Button color="secondary" variant="outlined" onClick={() => handleOpen(arrayHelpers)}>제품 찾기</Button>
            </Box>
            <Divider sx={{ my: 1 }} />
          </Box>

        )}

      >

      </FieldArray>
      <MasProductModalContainer
        title="공급 제품 추가 - 공급 제품 리스트"
        open={open}
        handleClose={handleClose}
        selectedProduct={selectedProducts}
      />
    </div>
  )
}



export default TechProductListForm